module.exports = __webpack_public_path__ + "static/media/bg-site.8a71ae07.jpeg";